import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import moment from "moment";
import 'moment-duration-format';
import { browserHistory as history } from 'react-router';
import { formatDate, isDefined, sortReactTable } from '../../../../../utils';
import { columnsAccessors } from '../../../../../constants';
import CallChannelIcon from '../../../../../icons/CallChannelIcon';
import EmailChannelIcon from '../../../../../icons/EmailChannelIcon';
import ChatChannelIcon from '../../../../../icons/ChatChannelIcon';
import PopupCustomized from '../../../../../components/PopupCustomized';
import HelpOutline from '@material-ui/icons/HelpOutline';

import {
    updateProps
} from '../../QaDashboardScreenActions';

class SuggestedAuditsSummaryTableForManager extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hoveredRowId: undefined
        };

        this.getTableColumns = this.getTableColumns.bind(this);
        this.setHoveredRow = this.setHoveredRow.bind(this);
        this.goToAudit = this.goToAudit.bind(this);

        this.showAuditedHelpPopup = this.showAuditedHelpPopup.bind(this);
        this.closeAuditedHelpPopup = this.closeAuditedHelpPopup.bind(this);

        this.showCoachedHelpPopup = this.showCoachedHelpPopup.bind(this);
        this.closeCoachedHelpPopup = this.closeCoachedHelpPopup.bind(this);

        this.showJibeIqHelpPopup = this.showJibeIqHelpPopup.bind(this);
        this.closeJibeIqHelpPopup = this.closeJibeIqHelpPopup.bind(this);
    }

    setHoveredRow(hoveredRowId) {
        this.setState({ hoveredRowId: hoveredRowId });
    }

    showAuditedHelpPopup(e) {
        this.setState({ showAuditedHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeAuditedHelpPopup() {
        this.setState({ showAuditedHelpPopup: false });
    }

    showCoachedHelpPopup(e) {
        this.setState({ showCoachedHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeCoachedHelpPopup() {
        this.setState({ showCoachedHelpPopup: false });
    }

    showJibeIqHelpPopup(e) {
        this.setState({ showJibeIqHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeJibeIqHelpPopup() {
        this.setState({ showJibeIqHelpPopup: false });
    }

    goToAudit(audit) {
        history.push(`/QualityAssurance/status/audit/${audit.zacousticTicketId}`);
        this.props.dispatch(updateProps({ selectedSuggestedAudit: audit }));
    }

    getTableColumns() {
        const
            {
                calibratedOnSurveyQuestions,
            } = this.props;
        let nameHeader = 'Agent Name';

        let interactionHeader = 'Interaction';
        let rfcHeader = 'RFC';

        const interactionColumn =
        {
            Header: interactionHeader,
            accessor: columnsAccessors.interactionExternalIdNode
        };

        const nameColumn = {
            Header: nameHeader,
            accessor: columnsAccessors.agentName,
        };

        const columns = [interactionColumn, nameColumn];

        if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
            calibratedOnSurveyQuestions.forEach(sq => {
                columns.push(
                    {
                        Header: `${sq.shortName}`,// Prediction /Response
                        accessor: `${sq.internalName}Answers`,
                        //width: 180
                    }
                );
            });
        }

        let auditedHeader =
            (<div className="flex-container-center">
                <div>Audited</div>
                <HelpOutline onClick={this.showAuditedHelpPopup}
                    style={{ fontSize: '20px', marginBottom: '6px' }} />
            </div>);

        let coachedHeader =
            (<div className="flex-container-center">
                <div>Coached</div>
                <HelpOutline onClick={this.showCoachedHelpPopup}
                    style={{ fontSize: '20px', marginBottom: '6px' }} />
            </div>);

        let jibeIqHeader =
            (<div className="flex-container-center">
                <div>JibeIQ</div>
                <HelpOutline onClick={this.showJibeIqHelpPopup}
                    style={{ fontSize: '20px', marginBottom: '6px' }} />
            </div>);

        columns.push(
            {
                Header: 'Handle Time (s)',
                accessor: 'totalTimeSpentInSecond'
            });
        columns.push(
            {
                Header: auditedHeader,
                accessor: 'auditedPast30DaysToShow'
            });
        columns.push(
            {
                Header: coachedHeader,
                accessor: 'coachedPast30DaysToShow'
            });
        //columns.push(
        //    {
        //        Header: jibeIqHeader,
        //        accessor: 'jibeIQScore'
        //    });
        columns.push(
            {
                Header: 'Audit',
                accessor: 'coachingAction'
            });
        return columns;
    }

    render() {
        const
            {
                calibratedOnSurveyQuestions,
                suggestedAudits,
            } = this.props;

        let result = {};
        result.columns = this.getTableColumns();
        const auditedHelpText = "Audited in past 30 days.";
        const coachedHelpText = "Coached in past 30 days.";
        const jibeIqHelpText = "JibeIQ is an AI powered quotient that automatically identifies the most important interactions for coaching. The higher the JibeIQ score, the more important it is for your team to audit and coach.";

        const loading = !suggestedAudits || !Array.isArray(suggestedAudits);
        if (loading === true) {
            return (
                <div>
                    <ReactTable
                        columns={result.columns}
                        defaultPageSize={5}
                        loading={loading}
                        showPagination={false}
                        className="interactions -striped -highlight -noheadercolor" />
                </div>);
        }

        result.data = suggestedAudits;

        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {

                if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
                    calibratedOnSurveyQuestions.forEach(sq => {
                        row[`${sq.internalName}Answers`] = <div>
                            {row[`${sq.internalName}`]}
                        </div>;
                    });
                }

                //if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
                //    calibratedOnSurveyQuestions.forEach(sq => {
                //        const agentAns = row[`${sq.internalName}AgentPrediction`] ? row[`${sq.internalName}AgentPrediction`] : '-';
                //        const customerAns = row[`${sq.internalName}CustomerResponse`] ? row[`${sq.internalName}CustomerResponse`] : '-';
                //        row[`${sq.internalName}Answers`] = `${agentAns}/${customerAns}`;
                //    });
                //}

                if (isDefined(row.startDate)) {
                    row.startDate = formatDate(row.startDate);
                }

                if (isDefined(row.auditedPast30Days)) {
                    row.auditedPast30DaysToShow = row.auditedPast30Days ? 'Yes' : 'No'
                }

                if (isDefined(row.coachedPast30Days)) {
                    row.coachedPast30DaysToShow = row.coachedPast30Days ? 'Yes' : 'No'
                }

                if (isDefined(row.externalNumber)) {
                    let channelIcon;
                    if (isDefined(row.channelType)) {
                        if (row.channelType.toLowerCase() == 'voice' || row.channelType.toLowerCase() == 'phone') {
                            channelIcon = <CallChannelIcon />
                        }
                        else if (row.channelType.toLowerCase() == 'chat') {
                            channelIcon = <ChatChannelIcon />
                        }
                        else if (row.channelType.toLowerCase() == 'email') {
                            channelIcon = <EmailChannelIcon />
                        }
                        else {
                            channelIcon = <div className="icon-square">{row.channelType}</div>
                        }
                    }
                    else {
                        channelIcon = <div className="icon-square">--</div>
                    }
                    row.interactionExternalIdNode =
                        (<div className="flex-container-center">
                            <div style={{ minWidth: '20px' }}>
                                {channelIcon}
                            </div>
                            <div style={{ margin: "0 0 0 10px" }}>{row.externalNumber}</div>
                        </div>)
                }

                row.coachingAction = '';
                if (row.zacousticTicketId === this.state.hoveredRowId) {
                    row.coachingAction = <div className="v3-button agent-view-interactions"
                        style={{ width: '80px', background: '#32A6AE' }}
                        onClick={() => this.goToAudit(row)}>
                        Audit
                    </div>
                }
            });
        }

        const teamsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={5}
            loading={loading}
            showPagination={false}
            className="interactions -striped -highlight -noheadercolor"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onMouseEnter: () => {
                            this.setHoveredRow(rowInfo.original.zacousticTicketId)
                        },
                        onMouseLeave: () => {
                            this.setHoveredRow(null)
                        },
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return (<div className="SuggestedAuditsSummaryTableForManager system-dashboard-jibe-border" style={{
            width: '165%', padding: '10px'
        }}>
            {teamsResultTable}
            {
                this.state.showAuditedHelpPopup &&
                <PopupCustomized
                    x={this.state.mouseClickX}
                    y={this.state.mouseClickY}
                    Message={auditedHelpText}
                    close={this.closeAuditedHelpPopup} />
            }
            {
                this.state.showCoachedHelpPopup &&
                <PopupCustomized
                    x={this.state.mouseClickX}
                    y={this.state.mouseClickY}
                    Message={coachedHelpText}
                    close={this.closeCoachedHelpPopup} />
            }
            {
                this.state.showJibeIqHelpPopup &&
                <PopupCustomized
                    x={this.state.mouseClickX}
                    y={this.state.mouseClickY}
                    Message={jibeIqHelpText}
                    close={this.closeJibeIqHelpPopup} />
            }
        </div>);
    };
}

const select = state => ({ ...state.QaDashboardManagerScreen });
export default connect(select)(SuggestedAuditsSummaryTableForManager);

